import React from "react";
import V_AutoImg from "assets/img/vAutoImg.png";

// Define the vauto component
const V_Auto = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://www.vauto.com/",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div onClick={openInNewTab}>
			<img src={V_AutoImg} alt="vAuto" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default V_Auto;
